/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useState, useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import { func } from 'prop-types';
import Swal from 'sweetalert2';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import useInput from '../hooks/useInput';
import AuthedContext from '../contexts/AuthedContext';
import { getBookingManual, putAccessToken } from '../utils/api';
import ShipRouteFilter from '../components/ShipRouteFilter';
import ShipFilter from '../components/ShipFilter';
import SubsidyToggler from '../components/SubsidyToggler';
import LoadingSpinner from '../components/LoadingSpinner';

function DataManual({ setInitiate }) {
  const [loading, setLoading] = useState(false);
  const { authedUser } = useContext(AuthedContext);
  const [searchParams, setSearchParams] = useSearchParams();
  // const [shipId, setShipId] = useInput(authedUser.shipId);
  const [shipRouteId, setShipRouteId] = useInput('');
  const dateParam = searchParams.get('date') || moment().format('YYYY-MM-D');
  const [bookingData, setBookingData] = useState([]);
  const [shipId, setShipId] = useInput('');
  const [subsidyStatus, setSubsidyStatus] = useState(false);
  const [selectedDate, setSelectedDate] = useState(() => (
    moment(dateParam, 'YYYY-MM-D', true).isValid() ? dateParam : moment().format('YYYY-MM-D')
  ));

  const setFormattedDate = (date) => {
    const formattedDate = moment(date).format('YYYY-MM-D');
    setSelectedDate(formattedDate);
    setSearchParams({ date: formattedDate });
  };

  const toggleSubsidyStatus = () => {
    setSubsidyStatus(!subsidyStatus);
  };

  useEffect(() => {
    if (shipRouteId && shipId) {
      setLoading(true);
      getBookingManual(selectedDate, shipRouteId, shipId, subsidyStatus)
        .then(({ statusCode, errorMessage, data }) => {
          if (data) {
            setBookingData(data);
            setLoading(false);
          } else if (statusCode === 401) {
            Swal.fire(
              'Failed',
              'Session anda telah habis, silahkan login kembali',
              'error',
            );
            putAccessToken('');
            setInitiate();
          } else {
            Swal.fire('Error', errorMessage, 'error');
            setLoading(false);
          }
        });
    }
  }, [shipRouteId, shipId, selectedDate, authedUser, subsidyStatus]);

  return (
    <section>
      <div className="row mb-2">
        <div className="col-sm-6 col-md-2 mb-2">
          <DatePicker className="form-control" dateFormat="dd/MM/yyyy" selected={new Date(selectedDate)} onChange={(date) => setFormattedDate(date)} />
        </div>
        <div className="col-sm-6 col-md-3 mb-2">
          <ShipRouteFilter selectedId={shipRouteId} setSelectedId={setShipRouteId} />
        </div>
        <div className="col-sm-6 col-md-3 mb-2">
          <ShipFilter selectedId={shipId} setSelectedId={setShipId} routeId={shipRouteId} />
        </div>

        <div className="col-12 mb-2">
          <SubsidyToggler subsidy={subsidyStatus} toggleSubsidy={toggleSubsidyStatus} />
        </div>

        <div className="col-12">
          <div className="table-responsive">
            <table className="table table-striped table-hover table-bordered">
              <thead>
                <tr className="text-nowrap">
                  <th className="text-start py-3" scope="col">Tanggal</th>
                  {
                    bookingData.length > 0 && (bookingData[0].embark_id === 'MWR' || bookingData[0].embark_id === 'WSR')
                    && <th className="py-3" scope="col">Rute</th>
                  }
                  <th className="py-3" scope="col">Kapal</th>

                  <th className="py-3 text-nowrap" scope="col">Jumlah E-VIP</th>
                  <th className="py-3" scope="col">Harga E-VIP</th>
                  <th className="py-3" scope="col">Jumlah E-Ekonomi</th>
                  <th className="py-3 text-nowrap" scope="col">Harga E-Ekonomi</th>

                  <th className="py-3" scope="col">Jumlah M-VIP</th>
                  <th className="py-3" scope="col">Harga M-VIP</th>
                  <th className="py-3" scope="col">Harga M-Ekonomi</th>
                  <th className="py-3" scope="col">Harga M-Ekonomi</th>

                  <th className="py-3" scope="col">Jumlah Non-Tiket</th>
                  <th className="py-3" scope="col">Harga Non-Tiket</th>
                  <th className="py-3" scope="col">Jumlah Free</th>

                  <th className="py-3" scope="col">Total Tiket</th>
                  <th className="py-3" scope="col">Total Harga</th>
                </tr>
              </thead>
              <tbody className="table-group-divider">
                {
                  loading ? (
                    <tr>
                      <td colSpan="11" className="text-center">
                        <LoadingSpinner />
                      </td>
                    </tr>
                  )
                    : bookingData.length === 0
                      ? (
                        <tr>
                          <td colSpan="15"><p className="text-center text-warning m-0">Data tidak ditemukan</p></td>
                        </tr>
                      )
                      : bookingData.map((row) => (
                        <tr key={row.id} className="text-nowrap">
                          <td>{row.date}</td>
                          {
                            (row.embark_id === 'MWR' || row.embark_id === 'WSR')
                            && <td>{`${row.embarkation} - ${row.destination}`}</td>
                          }
                          <td>{row.ship_name}</td>
                          <td>0</td>
                          <td>0</td>
                          <td>0</td>
                          <td>0</td>
                          <td>{row.book_vip_quantity}</td>
                          <td>{row.book_vip_prices}</td>
                          <td>{row.book_economy_quantity}</td>
                          <td>{row.book_economy_prices}</td>
                          <td>{row.book_nonticket_quantity}</td>
                          <td>{row.book_nonticket_prices}</td>
                          <td>{row.book_free_quantity}</td>
                          <td>0</td>
                          <td>0</td>
                        </tr>
                      ))
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}

DataManual.propTypes = {
  setInitiate: func.isRequired,
};

export default DataManual;
